import { Layout, Spin } from 'antd'
import React from 'react'
import AdminSlotForm from './AdminSlotForm'
import AdminSlotTabs from './AdminSlotTabs'
import AdminSlotActions from './AdminSlotActions'

export default function AdminSlotPage ({ form, slot, setSlot, loading, setLoading, cancel, back, delay }) {
  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white', marginTop: '2em', justifyContent: 'space-between' }}>
      <Spin spinning={loading} >
        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
          <div style={{ flexBasis: '49%' }}>
            <AdminSlotForm slot={slot} setLoading={setLoading} form={form} />
          </div>
          <div style={{ flexBasis: '49%' }}>
            <AdminSlotTabs slot={slot} setLoading={setLoading} setSlot={setSlot} />
          </div>
        </div>
        <AdminSlotActions form={form} slot={slot} cancel={cancel} back={back} delay={delay} />
      </Spin>
    </Layout >
  )
}
